import * as page_height from "./page_height";
import * as footer from "./footer";

/**
 * Gestion des formulaires V1.2
 * @returns {boolean}
 */
export function watch() {

    let form = document.querySelectorAll('' +
        '#MemberAddmemberForm, ' +
        '#member-moyen-paiement, ' +
        '#member-informations-personnelles, ' +
        '#member-site-principal'
    );

    if (form == null || form.length < 1) {
        return;
    }

    form.forEach(function (elm_form) {

        let member_type = elm_form.querySelector('#MemberMemberstypeId');
        let paiement_type = elm_form.querySelector('#MemberPaymentstypeId');

        if (member_type !== null) {

            member_type.addEventListener("change", function () {
                member_action(elm_form, member_type);
            });

            member_action(elm_form, member_type);
        }

        if (paiement_type !== null) {

            paiement_type.addEventListener("change", function () {
                paiement_action(elm_form, paiement_type);
            });

            paiement_action(elm_form, paiement_type);
        }

        // Ajout des attributes "required" et des astérisques
        Array.prototype.forEach.call(elm_form.getElementsByClassName('input required'), function (elm) {
            let input = elm.querySelectorAll('input, select');
            if (input[0] != null) {
                input[0].setAttribute("required", "");
                let label = input[0].parentElement.parentElement.parentElement.getElementsByTagName('label');
                if (label[0] != null) {
                    label[0].innerText = label[0].innerText.trim() + ' *';
                }
            }
        });

        // Bouton de validation
        let bouton = elm_form.querySelector('[type="submit"]');
        bouton.setAttribute('disabled', '');

        // Vérification de la complétion des champs requis
        let input_events = ['keyup', 'copy', 'paste', 'cut', 'change', 'select', 'input'];
        let inputs = elm_form.querySelectorAll('input[required], select[required], input[type="checkbox"]');

        function event_func() {
            return button_state(check_required_inputs(inputs), bouton);
        }

        // Anti emmerdeurs
        bouton.addEventListener('click', event_func);

        // Event sur tous les champs requis
        input_events.forEach(function (event) {

            Array.prototype.forEach.call(inputs, function (elm) {
                elm.addEventListener(event, function () {
                    event_func();

                    // Vérification des mots de passe
                    check_password(elm_form);
                });
            });
        });

        event_func();

        // Fonctions

        function check_password(target_form) {

            let mdp_field = target_form.querySelector('#MemberPassword');
            let mdp_confirmation_field = target_form.querySelector('#MemberPasswordConfirmation');

            if (mdp_field !== null && mdp_confirmation_field !== null) {

                if (mdp_field.value.length < 6 || mdp_confirmation_field.value !== mdp_field.value) {
                    button_state(false, bouton);
                }
            }
        }

    });

    return true;
}

function button_state(state, bouton) {
    if (state) {
        bouton.removeAttribute('disabled');
        bouton.removeAttribute('title');
    } else {
        bouton.setAttribute('disabled', '');
        bouton.setAttribute('title', 'Le formulaire est invalide');
    }
}

function check_required_inputs(inputs) {

    let result = true;

    if (inputs != null && inputs.length > 0) {
        inputs.forEach(function (elm) {

            if (elm.getAttribute('type') === "checkbox") {

                if (!elm.checked) {
                    result = false;
                }

            } else if (elm.hasAttribute('nojsvalidation')) {

                elm.removeAttribute('required');

            } else {

                if (elm.value.trim().length < 1) {
                    result = false;
                }
            }
        })
    }

    return result;
}

export function member_action(target_form, member_type) {

    let member = {
        MemberCompany: target_form.querySelector('#MemberCompany'),
        MemberSiren: target_form.querySelector('#MemberSiren'),
        MemberNumberVat: target_form.querySelector('#MemberNumberVat')
    };

    let member_type_2 = {
        'MemberCompany': 'flex',
        'MemberSiren': 'flex',
        'MemberNumberVat': 'none'
    };

    let member_type_3 = {
        'MemberCompany': 'flex',
        'MemberSiren': 'flex',
        'MemberNumberVat': 'flex'
    };

    let member_type_4 = {
        'MemberCompany': 'none',
        'MemberSiren': 'none',
        'MemberNumberVat': 'none'
    };

    if (member_type !== null) {

        switch (parseInt(member_type.value)) {
            case 2:
                setDisplay(member_type_2, member);
                break;
            case 3:
                setDisplay(member_type_3, member);
                break;
            case 4:
                setDisplay(member_type_4, member);
                break;
            default:
                setDisplay(member_type_4, member);
                break;
        }
    }
}

export function paiement_action(target_form, member_type) {

    let member = {
        MemberPaymentFrTitulaire: target_form.querySelector('#MemberPaymentFrTitulaire'),
        MemberPaymentFrCodeBank: target_form.querySelector('#MemberPaymentFrCodeBank'),
        MemberPaymentFrCompte: target_form.querySelector('#MemberPaymentFrCompte'),
        MemberPaymentFrBanque: target_form.querySelector('#MemberPaymentFrBanque'),
        MemberPaymentFrCodeGuichet: target_form.querySelector('#MemberPaymentFrCodeGuichet'),
        MemberPaymentFrCleRib: target_form.querySelector('#MemberPaymentFrCleRib'),
        MemberPaymentPaypal: target_form.querySelector('#MemberPaymentPaypal')
    };

    let member_type_1 = {
        'MemberPaymentFrTitulaire': 'none',
        'MemberPaymentFrCodeBank': 'none',
        'MemberPaymentFrCompte': 'none',
        'MemberPaymentFrBanque': 'none',
        'MemberPaymentFrCodeGuichet': 'none',
        'MemberPaymentFrCleRib': 'none',
        'MemberPaymentPaypal': 'none'
    };

    let member_type_3 = {
        'MemberPaymentFrTitulaire': 'none',
        'MemberPaymentFrCodeBank': 'none',
        'MemberPaymentFrCompte': 'none',
        'MemberPaymentFrBanque': 'none',
        'MemberPaymentFrCodeGuichet': 'none',
        'MemberPaymentFrCleRib': 'none',
        'MemberPaymentPaypal': 'flex'
    };

    let member_type_4 = {
        'MemberPaymentFrTitulaire': 'flex',
        'MemberPaymentFrCodeBank': 'flex',
        'MemberPaymentFrCompte': 'flex',
        'MemberPaymentFrBanque': 'flex',
        'MemberPaymentFrCodeGuichet': 'flex',
        'MemberPaymentFrCleRib': 'flex',
        'MemberPaymentPaypal': 'none'
    };

    if (member_type !== null) {

        switch (parseInt(member_type.value)) {
            case 1:
                setDisplay(member_type_1, member);
                break;
            case 3:
                setDisplay(member_type_3, member);
                break;
            case 4:
                setDisplay(member_type_4, member);
                break;
            default:
                setDisplay(member_type_1, member);
                break;
        }
    }
}

function setDisplay($array, obj) {

    for (let elm in $array) {
        if ($array.hasOwnProperty(elm)) {

            let target = obj[elm];

            if (target !== null) {

                // target.required = $array[elm] !== 'none';
                target.parentElement.parentElement.parentElement.style.display = $array[elm];
            }
        }
    }

    page_height.watch();
    footer.watch();
}